import { FormatterService } from "@/domain/services";
import { formatters } from "../utils/formatters";

export class CepFormatter implements FormatterService {
  searchValue = formatters.cep.searchValue;
  replaceValue = formatters.cep.replaceValue;

  format(value: string): string {
    return value.replace(this.searchValue, this.replaceValue).trim();
  }
}
